import { render, staticRenderFns } from "./LocationListView.vue?vue&type=template&id=2fe354d1&"
import script from "./LocationListView.vue?vue&type=script&lang=js&"
export * from "./LocationListView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports